import {CREATE_PROFILE_REQUEST, CREATE_PROFILE_REQUEST_ERROR, CREATE_PROFILE_REQUEST_SUCCESS, CREATE_USER_REQUEST, CREATE_USER_REQUEST_ERROR, CREATE_USER_REQUEST_SUCCESS } from './Constants';

export const createUserRequest = (payload) => ({
    type: CREATE_USER_REQUEST,
    payload : payload
});
export const createUserRequestSuccess = (msg) => ({
    type: CREATE_USER_REQUEST_SUCCESS,
    msg : msg
});
export const createUserRequestError = () => ({
    type: CREATE_USER_REQUEST_ERROR,
});

export const createProfileRequest = (payload) => ({
    type: CREATE_PROFILE_REQUEST,
    payload : payload
});
export const createProfileRequestSuccess = (msg) => ({
    type: CREATE_PROFILE_REQUEST_SUCCESS,
    msg : msg
});
export const createProfileRequestError = () => ({
    type: CREATE_PROFILE_REQUEST_ERROR,
});